module.exports = __webpack_public_path__ + "img/pago.d6d7e111.png";